import React from "react";

const Footer = () => {
  return (
    <div className="footer-container">
      See on{" "}
      <a
        href="https://github.com/illing2005/polygon-name-server"
        target="_blank"
        rel="noopener noreferrer"
      >
        Github
      </a>
      , by{" "}
      <a
        href="https://www.linkedin.com/in/sebastian-illing-62320249/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Sebastian Illing
      </a>
      .
    </div>
  );
};

export default Footer;
